import {
  IndexBreedComparisonsScreen,
  IndexBreedComparisonsScreenProps,
} from 'shared/screens/breeds/index-breed-comparisons';
import { withServerProps } from '@web/library/with-server-props';
import { Page } from '@web/components/page';
import { useTranslation } from 'react-i18next';

export default function IndexComparisons(props: IndexBreedComparisonsScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo
          .setTitle(t('breeds.index_comparisons.title', { breed: props.breed.name }))
          .setDescription(t('breeds.index_comparisons.description', { breed: props.breed.name }))
          .setImage(props.breed.avatar?.url)
      }
    >
      <IndexBreedComparisonsScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(IndexBreedComparisonsScreen.pageBuilder);
